import "core-js/modules/es6.regexp.split";

/**
 * Splits a string into words, then returns the first words and last word.
 * @param str
 */
export function splitLastWord(str) {
  var words = str.split(' ');
  var firstWords = words.length === 1 ? '' : words.splice(0, words.length - 1).join(' ') + ' ';
  var lastWord = words[words.length - 1];
  return [firstWords, lastWord];
}
/**
 * Make the first letter of a string uppercase.
 * @param str
 */

export function sentenceCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}